<template>
  <div class="column">
    <div class="row justify-end">
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList()">{{$t('processes.export')}}</q-btn>
      </div>
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" :to="{ name: 'suivi-des-delegations-form' }" icon-right="add_circle">{{$t('processes.create_suivi_des_delegations')}}</q-btn>
      </div>
    </div>
    <q-table flat wrap-cells
      :data="suiviDesDelegationsProcesses"
      :columns="columns"
      row-key="id"
      :rows-per-page-options="rowsPerPageOptions"
      :pagination.sync="pagination"
      :loading="loading"
      :filter="filter"
      @request="onRequest"
      binary-state-sort>
      <q-tr slot="body" slot-scope="props" :props="props"
        @click.native="$router.push({ name: 'suivi-des-delegations-form', params: { id: props.row.id } })"
        class="cursor-pointer">
        <q-td v-for="col in props.cols" :key="col.name" :props="props" :auto-width="col.autoWidth">
          <div v-if="col.value" v-html="col.value" />
        </q-td>
      </q-tr>
    </q-table>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import download from 'downloadjs'

export default {
  name: 'SuiviDesDelegationsList',

  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext }) {
    store.dispatch('processes/fetchFilters', 'delegation')
  },

  meta () {
    return {
      title: 'Suivi des délegations'
    }
  },

  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters({
      suiviDesDelegationsProcesses: 'processes/getProcesses',
      filters: 'processes/getFilters',
      rowsPerPageOptions: 'config/getRowsPerPageOptions'
    }),
    pagination: {
      ...mapGetters({ get: 'processes/getPagination' }),
      ...mapMutations({ set: 'processes/setPagination' })
    },
    filter () {
      return this.$route.meta.filter
    },

    columns () {
      console.log(this.suiviDesDelegationsProcesses, this.filters)
      if (this.suiviDesDelegationsProcesses.length === 0) return []
      else {
        const fields = ['agents', 'wallets', 'date_effet', 'date_previsionnelle_fin_pret', 'statut']
        const sortable = []

        return fields.map(key => {
          let label = this.$t(`processes.fields.${key}.label`)
          let align = 'left'
          let autoWidth = false
          let formatFn = val => val

          if (key === 'wallets') {
            label = 'Portefeuille'
            formatFn = val => val.map(wallet => wallet.NOMPTF).join(', ')
          } if (key === 'agents') {
            label = this.$t(`processes.fields.agent.label`)
            formatFn = val => val.map(agent => `${agent['PRENOM']} ${agent['NOMITV']}`).join(', ')
          } else if (key === 'date_previsionnelle_fin_pret') {
            label = this.$t(`processes.fields.date_prev_fin_de_pret.label`)
            formatFn = val => this.$formatDate(val)
          } else if (key === 'date_effet') {
            formatFn = val => this.$formatDate(val)
          } else if (key === 'statut') {
            formatFn = val => {
              if (val) return this.$t(`processes.status.${val}`)
              return ''
            }
            align = 'center'
          }

          return {
            name: key,
            align: align,
            label: label,
            field: key,
            format: formatFn,
            sortable: sortable.indexOf(key) >= 0,
            autoWidth: autoWidth
          }
        })
      }
    }
  },

  watch: {
    filters: {
      handler (newVal, oldVal) {
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    },
    '$route.meta.filter': {
      handler (newVal, oldVal) {
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    }
  },

  mounted () {
    // if (this.filters) {
    this.onRequest({ pagination: this.pagination })
    // }
    this.$store.commit('pages/setBreadcrumbs', [
      { label: this.$t('global.home'), to: { name: 'home' }, icon: 'home' },
      { label: this.$t('processes.processAgence'), to: { name: '' } },
      { label: this.$t('processes.title.suivi_des_delegations'), to: { name: 'suivi-des-delegations-en-cours' } },
      {}
    ])

    this.$store.commit('pages/setPageTitle', this.$t('processes.title.suivi_des_delegations'))
    this.$store.commit('pages/setTabs', [
      { name: 'suivi-des-delegations-en-cours', label: 'En cours', to: { name: 'suivi-des-delegations-en-cours' } },
      { name: 'suivi-des-delegations-archivés', label: 'Archivés', to: { name: 'suivi-des-delegations-archives' } }
    ])
  },

  methods: {
    onRequest ({ pagination, filter }) {
      this.$store.commit('processes/setPagination', pagination)
      this.loading = true

      let params = { ...pagination, filter: this.filter, typeProcess: 'delegation' }
      if (this.filters) this.filters.forEach(filter => { params[filter.id] = filter.value })

      this.$store.dispatch('processes/fetchProcesses', params)
        .finally(() => { this.loading = false })
    },

    exportList () {
      this.$axios.get('/api/processAgences/delegation/export', {
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'text/csv' }
      }).then(response => {
        download(response.data, 'delegation.csv')
      }).catch(this.$notifyError)
    }
  }
}
</script>
